/**
 * @file store.js
 */
import Vue from 'vue';
import Vuex from 'vuex';

import header from './header/index.js';
import home from './home.js';
import list from './list.js';
import editTopic from './editTopic/index';
import topicContent from './topicContent/index.js';
import common from './common/index.js';
import userInfo from './userInfo';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        header,
        home,
        list,
        editTopic,
        topicContent,
        common,
        userInfo
    }
});
